(function ($) {

const Init = (() => {

  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      smooth       = {},
      anime        = {},
      tab          = {},
      accordion    = {},
      modal        = {},
      align        = {},
      form         = {},
      ready        = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      wp           = {};

  website = {
    page          : document.body.dataset.page,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    scrollStart   : window.pageYOffset,
    breakpoint    : { pc: 1200, tb: 992, sp: 768, ss: 576 },
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,

    headTag       : document.getElementById('js-header'),
    objFit        : '.js-ofi .ofi',
  };

  load = {
    functions: [],
    length   : 0,
    loadClass: 'is-loaded',
  };
  resize = {
    functions     : [],
    length        : 0,
    // fps        : 60,
    isRunning     : false,
    animationFrame: null,
  };
  // scroll = {
  //   functions     : [],
  //   length        : 0,
  //   // fps        : 60,
  //   isRunning     : false,
  //   animationFrame: null,
  // };


  const WinLoad = {

    init() {
      $(window).on('load', function() {
        WinLoad.update();
      });

      console.log('!-- load init --!');
    },

    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },

    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },

    update() {
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },

  }


  const WinResize = {

    init() {
      $(window).on('resize', function() {
        if ( !resize.isRunning ) {
          resize.isRunning = true;

          resize.animationFrame = window.requestAnimationFrame( WinResize.update );

          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update;
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });

      console.log('!-- resize init --!');
    },

    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },

    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },

    update() {
      website.winWidth  = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.ua        = navigator.userAgent.toLowerCase();

      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }

      resize.isRunning = false;
    },

  }


  // const WinScroll = {

  //   init() {
  //     $(window).on('scroll', function() {
  //       if ( !scroll.isRunning ) {
  //         scroll.isRunning = true;

  //         scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );

  //         // if ( window.requestAnimationFrame ) {
  //         //   window.requestAnimationFrame(() => {
  //         //     WinScroll.update;
  //         //   });
  //         // } else {
  //         //   setTimeout(() => {
  //         //     WinScroll.update();
  //         //   }, 1000/scroll.fps);
  //         // }
  //       }
  //     });

  //     console.log('!-- scroll init --!');
  //   },

  //   add(func) {
  //     scroll.functions.push(func);
  //     scroll.length = scroll.functions.length;
  //   },

  //   remove(func) {
  //     scroll.functions.splice(func, 1);
  //     scroll.length = scroll.functions.length;
  //   },

  //   update() {
  //     website.winHeight = window.innerHeight;
  //     website.scrollY = window.pageYOffset;

  //     for ( let i = 0; i < scroll.length; i++ ) {
  //       let func = scroll.functions[i];
  //       func();
  //     }

  //     scroll.isRunning = false;
  //   },

  // }


  const Modules = {

    init() {
      smooth = {
        linkClass: 'js-scroll',
        speed    : 600,
      };

      // anime = {
      //   watchClass: 'js-anime',
      //   actClass  : 'is-anime',
      // };

      tab = {
        btnWrap   : 'js-tabbtn',
        contsWrap : 'js-tabconts',
        actClass  : 'is-act',
        viewClass : 'is-view',
        navBtn    : 'js-news_nav',
        prevBtn   : '.wp-pagination .prev',
        nextBtn   : '.wp-pagination .next',
      };

      accordion = {
        btnClass: 'js-accordion',
        actClass: 'is-act',
      };

      modal = {
        openClass   : 'js-modal',
        closeClass  : 'js-modal_close',
        actClass    : 'is-open',
        actWrapClass: 'is-act',
        actBodyClass: 'is-modal',
      };

      align = {
        watchClass: 'js-align',
        addClass  : 'c-alignheight',
        height    : 0,
      };

      form = {
        formSec   : '#contact',
        sendClass : 'js-btn_send',
        sendTarget: '.c-btn_color.-send',
        errorClass: 'error',
      };

      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      this.tabBtn();
      this.accordionBtn();
      this.modalBtn();
      this.setForm();

      objectFitImages(website.objFit);

      // if ( location.hash != "" && location.hash != "#" ) {
      //   $('body,html').stop().scrollTop(0);
      // }
    },

    iosCheck() {
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        $('body').addClass('ios');
      } else {
        $('body').removeClass('ios');
      }
    },

    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc tablet').addClass('sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc sp').addClass('tablet');
      } else {
        website.isDesktop = true;
        $('body').removeClass('tablet sp').addClass('pc');
      }
    },

    smoothScroll() {
      $('.' + smooth.linkClass + ':not([href=""])').on('click', function() {
        let href     = $(this).attr("href"),
            target   = $( (href == "#" || href == "") ? 'html' : href ),
            shift,
            position;

        shift = 0;
        position = target.offset().top - shift;
        if ( href == '#' ) { position = 0; }
        $('body,html').animate({scrollTop: position}, smooth.speed, 'swing');
        return false;
      });
    },

    // animation() {
    //   $('.' + anime.watchClass + ':not(.' + anime.actClass + ')').each(function(){
    //     let self = $(this),
    //         targetPosition = self.offset().top,
    //         triggerPosition,
    //         shift;

    //     if( website.winWidth < website.breakpoint.tb ) {
    //       shift = website.winHeight / 10;
    //     } else {
    //       shift = website.winHeight / 5;
    //     }
    //     triggerPosition = targetPosition - website.winHeight + shift;

    //     if( website.scrollY > triggerPosition ){
    //       self.addClass(anime.actClass);
    //     }
    //   });
    // },

    tabBtn() {
      $('#' + tab.btnWrap + ' > li > a').on('click', function(){
        let tabHref   = $(this).attr('href'),
            clickWrap = $('#' + tab.btnWrap),
            tabObj    = clickWrap.find('a'),
            contsObj  = $('#' + tab.contsWrap).children('div');

        if ( clickWrap.hasClass('wp-pagination') ) {
          let num     = $(this).parent().data('num'),
              prev    = $(tab.prevBtn),
              next    = $(tab.nextBtn),
              listPos = 1,
              listEnd = next.data('end'),
              actLi   = clickWrap.children('.' + tab.viewClass);

          if ( listEnd > 5 ) {
            actLi.removeClass(tab.viewClass);
            listPos = ( (num - 2) <= 1 ) ? 1: (num - 2);
            if ( num == listEnd ) {
              listPos -= 2;
            } else if( (num + 1) == listEnd ) {
              listPos -= 1;
            }

            if ( (num - 3) <= 0 ) {
              prev.parent().hide();
            } else {
              prev.parent().show();
            }
            if ( (listEnd - num) <= 3 ) {
              next.parent().hide();
            } else {
              next.parent().show();
            }
            $('li[data-num="' + listPos + '"]').addClass(tab.viewClass);
          }
        }

        tabObj.removeClass(tab.actClass);
        $(this).addClass(tab.actClass);

        contsObj.hide();
        $(tabHref).fadeIn();
        return false;
      });

      $('.' + tab.navBtn).on('click', function(){
        let clickWrap = $('#' + tab.btnWrap),
            listPos   = clickWrap.find('.is-act').parent().data('num');

        if ( $(this).hasClass('prev') ) {
          $('a[href="#news' + (listPos - 1) + '"]').click();
        } else {
          $('a[href="#news' + (listPos + 1) + '"]').click();
        }
      });
    },

    accordionBtn() {
      $('.' + accordion.btnClass).on('click', function(){
        if ( $(this).hasClass(accordion.actClass) ) {
          $(this).removeClass(accordion.actClass).next().stop().slideUp('fast');
          // $(this).removeClass(accordion.actClass);
        } else {
          $(this).addClass(accordion.actClass).next().stop().slideDown();
          // $(this).addClass(accordion.actClass);
        }
      });
    },

    modalBtn() {
      $(document).on('click', '.' + modal.openClass, function(e){
        let href = $(this).attr("href");
        $('body').addClass(modal.actBodyClass);
        $(href).addClass(modal.actClass).parent().addClass(modal.actWrapClass);
        return false;
      });

      $(document).on('click', '.' + modal.closeClass, function(){
        $('body').removeClass(modal.actBodyClass);
        $(this).nextAll('.' + modal.actClass).removeClass(modal.actClass).parent().removeClass(modal.actWrapClass);
      });
    },

    alignHeight() {
      align.height = 0;
      let alignList    = document.querySelectorAll('.' + align.watchClass),
          targetsAlign = Array.prototype.slice.call(alignList, 0);

      targetsAlign.forEach((target) => {
        target.style.minHeight = 'auto';
        target.classList.add(align.addClass);
        align.height = ( target.offsetHeight > align.height ) ? target.offsetHeight: align.height;
        target.classList.remove(align.addClass);
      });
      targetsAlign.forEach((target) => {
        target.style.minHeight = align.height + 'px';
      });
    },

    setForm() {
      $('.' + form.sendClass).on('click', function(){
        $(form.sendTarget).click();
      });

      if ( $('.' + form.errorClass).length ) {
        let target   = $( form.formSec ),
            shift = 0,
            position;
        position = target.offset().top - shift;
        $('body,html').animate({scrollTop: position}, smooth.speed, 'swing');
        return false;
      }
    },

    loaded() {
      $('body').addClass(load.loadClass);

      if ( location.hash != "" && location.hash != "#" ) {
        let shift    = 0,
            position = $(location.hash).offset().top - shift;
        $('body, html').animate({scrollTop: position}, smooth.speed, 'swing');
      } else {
        // $('body, html').animate({scrollTop: 0}, 100, 'swing');
      }
    },

  }


  const PageScroll = {

    init() {
      scrollOption = {
        target    : document.getElementById('js-contbox'),
        translateY: 0,
        contHeight: 0,
        velocity  : 0.08,

        targetAbout: document.getElementById('about'),
        headAct    : 'is-view',

        observerTarget : '.js-anime',
        observerAct    : 'is-anime',
        rootMargin     : '0px',
        threshold      : 0.1,
      };

      this.observer();
    },

    set() {
      scrollOption.contHeight    = scrollOption.target.getBoundingClientRect().height - 1;
      document.body.style.height = Math.floor(scrollOption.contHeight) + 'px';
    },

    smooth() {
      this.set();

      let diff = website.scrollY - scrollOption.translateY;

      if ( diff !== 0 ) {
        if ( Math.abs(diff) > 1 ) {
          scrollOption.translateY += diff * scrollOption.velocity;
        } else {
          scrollOption.translateY = website.scrollY;
        }
        scrollOption.target.style.transform = 'translate3d(0, -' + scrollOption.translateY + 'px, 0)';
      }
    },

    headerFix() {
      if ( website.scrollY != website.scrollStart ) {
        let aboutPos = (scrollOption.targetAbout != null) ? scrollOption.targetAbout.getBoundingClientRect().top + website.scrollY: 0;
        if ( website.scrollY >= aboutPos ) {
          website.headTag.classList.add(scrollOption.headAct);
        } else {
          website.headTag.classList.remove(scrollOption.headAct);
        }
        // website.scrollStart = website.scrollY;
      }
    },

    observer() {
      let nodeList = document.querySelectorAll(scrollOption.observerTarget),
          targets  = Array.prototype.slice.call(nodeList, 0),
          options = {
            rootMargin : scrollOption.rootMargin,
            threshold  : scrollOption.threshold,
          };
      let observer = new IntersectionObserver(this.observerCallback, options);

      let delayList    = document.querySelectorAll('[data-delay]'),
          targetsDelay = Array.prototype.slice.call(delayList, 0);
      targetsDelay.forEach((target) => {
        if ( target.dataset.delay ) {
          target.style.transitionDelay = target.dataset.delay + 'ms';
        }
      });

      let wordList    = document.querySelectorAll('.-word'),
          targetsWord = Array.prototype.slice.call(wordList, 0),
          delayHead   = 0;
      targetsWord.forEach((target) => {
        let text  = target.innerHTML,
            html  = '',
            delay = 100,
            num   = 1;

        if( target.classList.contains('-header') == true ){
          delay += delayHead;
          delayHead += 100;
        }

        text.split(' ').forEach(function (w) {
          if ( w == '<br>' ) {
            html += w;
          } else {
            html += '<span><span style="transition-delay: ' + delay + 'ms;">' + w + '</span></span>';
          }
          delay += 20;
        });
        target.innerHTML = html;
      });

      targets.forEach((target) => {
        observer.observe(target);
      });
    },

    observerCallback(entries, object) {
      entries.forEach(function(entry, i) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(scrollOption.observerAct);
        object.unobserve(entry.target);
      });
    },
  }


  const Parallax = {

    init() {
      parallax = {
        nodeList   : document.querySelectorAll('.js-parallax'),
        gap        : 0.08,

        bgList     : [],
        decoList   : [],
      };

      let targets = Array.prototype.slice.call(parallax.nodeList, 0);
      targets.forEach((target) => {
        if ( target.dataset.para ) {
          let arr = target.dataset.para.split(',');;
          parallax.decoList.push( [target, arr] );
        } else {
          parallax.bgList.push( target );
        }
      });
    },

    bgImg() {
      parallax.bgList.forEach((target) => {
        let targetRect = target.getBoundingClientRect(),
            translateY;

        if ( (targetRect.top - website.winHeight) <= 0 ) {
          translateY = targetRect.top * parallax.gap;
          target.style.transform = 'scale(1.25) translate3d(0, ' + translateY + 'px, 0)';
        }
      });
    },

    decoImg() {
      parallax.decoList.forEach((target) => {
        let targetRect = target[0].getBoundingClientRect(),
            parentNode = document.querySelector(target[1][0]),
            parentRect = parentNode.getBoundingClientRect(),
            diff       = targetRect.top - parentRect.top,
            gap        = (target[1][3]) ? Number(target[1][3]): parallax.gap,
            translateX,
            translateY;

        if ( (targetRect.top - website.winHeight) <= 0 ) {
          if ( target[1][1] == 'X' ) {
            translateX = ( target[1][2] == 'reverse' ) ? -((targetRect.top - diff) * gap): (targetRect.top - diff) * gap;
            target[0].style.transform = 'translate3d(' + translateX + 'px, 0px, 0px)';
          } else {
            translateY = ( target[1][2] == 'reverse' ) ? -((targetRect.top - diff) * gap): (targetRect.top - diff) * gap;
            target[0].style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
          }

        }
      });
    },

  }


  const DrawerMenu = {

    init() {
      drawer = {
        panel       : 'js-so_panel',
        menu        : 'js-so_menu',
        duration    : 10,
        // openclass   : 'slideout-open',
        nodeList    : '#js-so_toggle, #js-so_panel',
        closeList   : '#js-so_menu .js-scroll',
      };

      this.menu();
    },

    menu() {
      let slideoutInst = new Slideout({
        'panel': document.getElementById(drawer.panel),
        'menu': document.getElementById(drawer.menu),
        'duration': drawer.duration,
        // 'openclass': drawer.openclass,
      });

      let nodeList = document.querySelectorAll(drawer.nodeList);
      let node = Array.prototype.slice.call(nodeList,0);
      node.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.toggle();
        });
      });

      let nodeListClose = document.querySelectorAll(drawer.closeList);
      let nodeClose = Array.prototype.slice.call(nodeListClose,0);
      nodeClose.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.close();
        });
      });
    },

  }


  const Wordpress = {

    init() {
      wp = {
        editorId: 'js-editor',
        tableWrap: 'c-tblwrap',
        iframeWrap: 'c-iframe',
      }

      this.wpEditor();
    },

    wpEditor() {
      if ( document.getElementById(wp.editorId) != null ) {
        $( '#' + wp.editorId + ' table' ).each(function() {
          $(this).wrap('<div class="' + wp.tableWrap + '"></div>');
        });
        $( '#' + wp.editorId + ' iframe' ).each(function() {
          $(this).wrap('<div class="' + wp.iframeWrap + '"></div>');
        });
      }
    }

  }


  const Slick = {

    init() {
    },

    topGallery() {
      $('#js-sld_idx').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 800,
        slidesToShow: 1,
        arrows: true,
        prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',
        nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',
        dots: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive:[
          {
            breakpoint: 768,
            settings:{
              slidesToShow: 1,
              arrows: false,
              dots: true,
            }
          },
        ]
      });
    },

  }


  const Top = {

    init() {
      Slick.topGallery();
      Top.contact();
    },

    update() {
    },

    bgFix() {
      let about      = $('#about'),
          our        = $('#js-bgfix_our'),
          gallery    = $('#js-sld_idx'),
          news       = $('#js-bgfix_news'),
          recruit    = $('#js-bgfix_recruit'),
          contact    = $('#js-bgfix_contact'),
          aboutPos   = about.offset().top,
          ourPos     = (our.offset().top + our.outerHeight()) - website.winHeight,
          galleryPos = gallery.offset().top - website.winHeight,
          newsPos    = (news.offset().top + news.outerHeight()) - website.winHeight,
          recruitPos = (recruit.offset().top + recruit.outerHeight()) - website.winHeight,
          contactPos = (contact.offset().top + contact.outerHeight()) - website.winHeight,
          classAll   = 'is-our is-gallery is-news is-recruit is-contact';
          target     = $('#js-bgfix');
      if ( website.scrollY < aboutPos ) {
        $('body').removeClass('is-fix');
        target.removeClass(classAll);
      } else {
        $('body').addClass('is-fix');
        if ( website.scrollY >= contactPos ) {
          target.addClass(classAll);
        } else if( website.scrollY >= recruitPos ) {
          target.removeClass('is-contact').addClass('is-our is-gallery is-news is-recruit');
          $('#news .c-post_news').addClass('-blue');
        } else if( website.scrollY >= newsPos ) {
          target.removeClass('is-contact is-recruit').addClass('is-our is-gallery is-news');
          $('#news .c-post_news').removeClass('-blue');
        } else if( website.scrollY >= galleryPos ) {
          target.removeClass('is-contact is-recruit is-news').addClass('is-our is-gallery');
        } else if( website.scrollY >= ourPos ) {
          target.removeClass('is-contact is-recruit is-news is-gallery').addClass('is-our');
        } else {
          target.removeClass(classAll);
        }
      }
    },

    contact() {
      $('.js-select_close').on('click', function(){
        $(this).prev('input').prop('checked', false);
      });
    },

  }


  const BasicPage = {

    init() {
    },

    update() {
    },

  }


  const App = {

    init() {
      this.set();
      this.update();
    },

    set() {
      // WinLoad.add(Modules.animation);
      WinLoad.add(Modules.alignHeight);
      WinLoad.add(Modules.loaded);

      WinResize.add(Modules.iosCheck);
      WinResize.add(Modules.deviceCheck);
      WinResize.add(Modules.alignHeight);

      // WinScroll.add(Modules.animation);

      Modules.init();
      PageScroll.init();
      Parallax.init();
      DrawerMenu.init();
      Wordpress.init();

      if ( website.page == 'top' ) {
        Top.init();
      } else {
        // BasicPage.init();
      }


      WinLoad.init();
      WinResize.init();
      // WinScroll.init();
    },

    update() {
      website.animationFrame = window.requestAnimationFrame( App.update );
      website.winHeight      = window.innerHeight;
      website.scrollY        = window.pageYOffset;

      if ( website.isDesktop ) {
        PageScroll.smooth();
        Parallax.bgImg();

        if ( website.page == 'top' ) {
          Parallax.decoImg();
        }
      } else {
        PageScroll.set();
      }

      if ( website.page == 'top' ) {
        Top.bgFix();
      }

      PageScroll.headerFix();
    },

  }


  App.init();

})();

})(jQuery);
